export default __webpack_public_path__ + "static/media/logo-c3.26eb522e.png";